export default class Util {
  static capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static number_format(number, decimals = 2, dec_point ='.', thousands_sep = ' ') {
    number = (number + '')
      .replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      s = '',
      toFixedFix = function(n, prec) {
        var k = Math.pow(10, prec);
        return '' + (Math.round(n * k) / k)
          .toFixed(prec);
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
      .split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '')
        .length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1)
        .join('0');
    }
    return s.join(dec);
  }

  static validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  static plural(n, forms) {
    return forms[n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2];
  }

  static declOfNum(number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
  }

  // Тут неразрывные пробелы, а не обычные!
  // должен полностью повторять хелпер php
  static format_price(price, return_arr = false) {
    const decimals = Util.fmod(price, 1) > 0 ? 2 : 0
    let formatted_price = Util.number_format(price, decimals, '.', ' ')

    const formatted_price_arr = formatted_price.split('.')
    if (return_arr) {
      return formatted_price_arr;
    }

    formatted_price = formatted_price_arr[0]
    if (formatted_price[1]) {
      let cop = `<sup class="price-decimal-sup">${formatted_price[1]} коп.</sup>`

      return `${formatted_price} руб ${cop}`
    }

    return `${formatted_price} Р`
  }

  static fmod(a,b) {
    return Number((a - (Math.floor(a / b) * b)).toPrecision(8));
  }
}
